import { StoreState } from '@/redux/types';
import { getAreSpecialFontsAvailable } from './getAreSpecialFontsAvailable';
import { getCore } from './getCore';

export const getSpecialFonts = (state: StoreState) =>
  getAreSpecialFontsAvailable(state) ? getCore(state).specialFonts : [];
